import React from "react";
import img from "../../assets/img/teeth.png";
import finance from "../../assets/img/finance.png";
import smile from "../../assets/img/smile.png";

const Services = () => {
  return (
    <div className="container-fluid bg-white py-5">
      <div className="px-lg-5 pt-5 align-items-center">
        <div className="row">
          <div className="col-md-4 d-flex flex-column align-items-center my-3 px-lg-5">
            <img
              src={img}
              className="rounded-4"
              height="90"
              loading="lazy"
              alt="Dental Icon"
            />
            <h3 className="text-dark fs-18 fw-800 pt-2">Smiles in Months</h3>
            <p className="text-dark fs-17 fw-400 text-center lh-lg">
              With our experts, you can have your new smile quicker than you
              think
            </p>
          </div>

          <div className="col-md-4 d-flex flex-column align-items-center border-md-left my-3 px-lg-5">
            <img
              src={smile}
              className="rounded-4"
              height="90"
              loading="lazy"
              alt="Smile Icon"
            />
            <h3 className="text-dark fs-18 fw-800 pt-2">Smile Evaluation</h3>
            <p className="text-dark fs-17 fw-400 text-center lh-lg">
              See your smile before going <br></br> ahead with treatment
            </p>
          </div>

          <div className="col-md-4 d-flex flex-column align-items-center border-md-left my-3 px-lg-5">
            <img
              src={finance}
              className="rounded-4"
              height="90"
              loading="lazy"
              alt="Finance Icon"
            />
            <h3 className="text-dark fs-18 fw-800 pt-2">Flexible Payments</h3>
            <p className="text-dark fs-17 fw-400 text-center lh-lg">
              A wide range of payment options, including 0% over 12 months
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
